export default {
	confirmationView: {
		buttons: {
			cancel: 'Cancel',
			placeBids: 'Place bids',
		},
		heading: 'Bulk bidding confirmation',
		info: 'Please review the {numberOfVehicles} vehicle{pluralisation} listed below before submitting your bids.',
		note: 'Note: Bids will only be placed on vehicles currently in the Live sale.',
	},
	datagrid: {
		reservePrice: 'Reserve price',
		vehicleDetails: 'Vehicle details',
		yourBid: 'Your bid',
	},
	processingView: {
		heading: 'Processing bids',
		info: 'Please keep this window open until the upload is complete to ensure your bids are submitted successfully.',
		processedBids: {
			ariaLabel: 'Progress of bids processed',
			progress: '{processed} out of {total} processed',
		},
	},
	resultsView: {
		chip: {
			failed: 'Failed bids {numberOfBids}',
			successful: 'Successful bids {numberOfBids}',
		},
		heading: 'Bulk bidding results',
		info: {
			base: `Review the results of your bulk upload below. {successfulConnector}{failedConnector}`,
			failed: {
				plural: '{failedBidsLength} bids failed to process.',
				singular: '{failedBidsLength} bid failed to process.',
			},
			successful: {
				plural: '{successfulBidsLength} bids were submitted successfully, however, ',
				singular: '{successfulBidsLength} bid was submitted successfully, however, ',
			},
		},
		infoBox: {
			content: {
				bidsAndOffers: 'Bids & Offers',
				failed:
					'Some bids could not be submitted due to the below reasons. Please click each vehicle to bid directly on its profile page.',
				successful: 'You can view your submitted bids below or by visiting the {link} section in your account.',
			},
			heading: {
				failed: {
					plural: '{numberOfBids} bids have failed to process',
					singular: '{numberOfBids} bid has failed to process',
				},
				successful: {
					plural: '{numberOfBids} bids were successfully submitted',
					singular: '{numberOfBids} bid was successfully submitted',
				},
			},
		},
	},
	toast: {
		failedToFetchVehicles: {
			content: 'There was an issue with uploading your CSV. Please try again.',
			heading: 'CSV upload failed',
		},
		noLiveSaleVehicles: {
			content: "The CSV uploaded didn't contain any vehicles in the current Live sale.",
			heading: 'No available vehicles',
		},
		successful: {
			bidsAndOffers: 'Bids & Offers',
			content:
				'Your CSV was successfully uploaded and all bids have been placed. To view your submitted bids, visit your {bidsAndOffers} section in your account.',
			heading: '{successfulBidsLength} bids successfully submitted',
		},
		uploadFailed: {
			content: 'Your CSV could not be uploaded. Please ensure it matches the format of the download and try again.',
			heading: 'CSV upload failed',
		},
		uploadFailedTooManyBids: {
			content:
				'Your CSV contains more than the maximum number of bids permitted. Please ensure your CSV has no more than {maxEnquiries} bids.',
			heading: 'CSV upload failed',
		},
	},
	tooltip: 'Upload CSV',
};
